import axios from "axios";
import { getClientEnv } from "@/config/clientEnv";

// Determinar la URL base según el entorno
let isDevelopment = false;
let baseURL = "https://www.propiedadeslatam.com";

// Compatibilidad con entorno de servidor (Node.js) y cliente (Vite)
if (typeof process !== 'undefined' && process.env) {
  // Entorno Node.js (servidor)
  isDevelopment = process.env.NODE_ENV !== 'production';
  baseURL = isDevelopment 
    ? process.env.API_URL || "http://localhost:3000" 
    : "https://www.propiedadeslatam.com";
} else if (typeof window !== 'undefined') {
  // Entorno del navegador (cliente)
  const { mode, apiUrl } = getClientEnv();
  isDevelopment = mode === 'development';
  baseURL = isDevelopment 
    ? "http://localhost:3000" 
    : "https://www.propiedadeslatam.com";
  
  console.log('[axios] Configurando cliente con:', { 
    mode, 
    apiUrl, 
    isDevelopment,
    baseURL
  });
}

// Verificar si la URL es válida
if (typeof window !== 'undefined') {
  // Si estamos en producción pero la URL apunta a localhost, corregir
  if (window.location.hostname !== 'localhost' && baseURL.includes('localhost')) {
    console.warn(`[axios] ⚠️ La URL de la API (${baseURL}) apunta a localhost pero la aplicación se está ejecutando en ${window.location.hostname}`);
    // Corregir automáticamente
    baseURL = 'https://www.propiedadeslatam.com';
    console.warn(`[axios] Corrigiendo URL de API a: ${baseURL}`);
  }
}

// Función para asegurarse de que las rutas tengan el prefijo /api
const ensureApiPrefix = (url: string) => {
  if (!url.startsWith('/')) url = '/' + url;
  if (!url.startsWith('/api/')) url = '/api' + url;
  return url;
};

export const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  },
  withCredentials: true,
  timeout: 15000 // 15 segundos
});

// Solo ejecutar este código en el navegador
if (typeof window !== 'undefined') {
  api.interceptors.request.use((config) => {
    // Asegurarse de que la URL tenga el prefijo /api
    if (config.url) {
      config.url = ensureApiPrefix(config.url);
    }
    
    // Registrar información de la solicitud para depuración
    console.log(`[axios] Enviando solicitud a: ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    
    // Obtener el token del localStorage
    const token = localStorage.getItem("token");
    
    // Si hay un token, añadirlo a los headers
    if (token) {
      console.log('[axios] Token encontrado, añadiendo a la solicitud');
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('[axios] No se encontró token de autenticación');
    }
    
    // Asegurarse de que withCredentials esté siempre activado
    config.withCredentials = true;

    // Asegurarse de que la URL base sea correcta en producción
    if (window.location.hostname !== 'localhost' && config.baseURL?.includes('localhost')) {
      config.baseURL = 'https://www.propiedadeslatam.com';
    }

    return config;
  }, (error) => {
    console.error('[axios] Error en la configuración de la solicitud:', error);
    return Promise.reject(error);
  });

  api.interceptors.response.use(
    (response) => {
      console.log(`[axios] Respuesta exitosa de: ${response.config.url}`);
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        console.warn('[axios] Error 401: No autorizado');
        localStorage.removeItem("token");
        window.location.href = "/login";
      } else if (!error.response || error.code === 'ERR_NETWORK') {
        console.error('[axios] Error de red en la solicitud:', error);
        console.error('[axios] URL de la solicitud:', error.config?.url);
        console.error('[axios] Método de la solicitud:', error.config?.method);
        console.error('[axios] URL base:', error.config?.baseURL);
        
        // Si la URL base es localhost en producción, intentar con la URL de producción
        if (window.location.hostname !== 'localhost' && error.config?.baseURL?.includes('localhost')) {
          error.config.baseURL = 'https://www.propiedadeslatam.com';
          return api.request(error.config);
        }
      }
      return Promise.reject(error);
    }
  );
} 